import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MediaDevScreen } from './screen/dev/component';

const routes: Routes = [
  {
    path: 'dev',
    pathMatch: 'full',
    component: MediaDevScreen,
  },
];

// TODO: Move to the library. @victor-shelepen
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MediaRoutingModule {}
